import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Game from './Components/Game';
import Navbar from "./Components/Navbar";
import SinglePlayerForm from "./Components/SinglePlayerForm";
import Player from "./Components/Players";
import DoublePlayerForm from "./Components/DoublePlayerForm";

const Wrap = () => {
  return (
    <div>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navbar />} />
        <Route path="/game" element={<Game />} />
        <Route path="/singlePlayer" element={<SinglePlayerForm />} />
        <Route path="/doublePlayer" element={<DoublePlayerForm />} />
        <Route path="/players" element={<Player />} />
      </Routes>
    </BrowserRouter>

    </div>
  )
}                              

export default Wrap